import styled from "@emotion/styled"
import { FormControlLabel, FormGroup, Typography } from "@mui/material"

export const Wrapper = styled.div``

export const Title = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: ${({ theme }) => theme.typography.pxToRem(16)};
  font-family: ${({ theme }) => theme.fonts.tertiary};
  font-weight: 500;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.palette.tertiary.dark};
  margin-bottom: 0.9rem;
`

export const CustomFormGroup = styled(FormGroup)`
  flex-direction: column;
  gap: 0.5rem;
  max-width: 550px;
`

export const CustomFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-family: ${({ theme }) => theme.fonts.tertiary};
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0.15px;
    color: ${({ theme }) => theme.palette.text.content};
  }
  .MuiSvgIcon-root {
    color: black;
  }
`
